<template>
    <div id="whatsapp-channel-detail">
        <div class="wrapper" v-if="channel">
            <div class="toolbar">
                <div class="left">
                    <IconButton :on-click="() => $router.push('/integrations/whatsapp-v2')">
                        <span class="material-icons"> chevron_left </span>
                    </IconButton>
                    <div class="icon-container">
                        <WhatsappIcon />
                    </div>
                    <div class="name">Whatsapp V2 Channel :{{ channel.name }}</div>
                </div>
                <div class="right" v-show="channel">
                    <a-button type="primary" @click="visible = true" :loading="loading">
                        {{ $t("wp.startChatWithAnyNo") }}
                    </a-button>
                    <a-button type="primary" @click="refreshhannel"> Refresh </a-button>
                    <a-button type="primary" @click="restartChannel" :disabled="!restartEnabled">
                        {{ $t("whatsappChannel.restartChannel") }}
                    </a-button>
                    <a-button type="danger" @click="deleteModal = true"
                        >{{ $t("whatsappChannel.deleteChannel") }}
                    </a-button>
                </div>
            </div>
            <div class="channel-content">
                <div class="left">
                    <ChannelMenu v-model="currentTab" />
                </div>
                <div class="page-content" v-if="channel">
                    <div v-if="currentTab === WhatsappChannelMenuTypes.INTEGRATION.id">
                        <WhatsappWizard :channel="channel" />
                    </div>
                    <div v-if="currentTab === WhatsappChannelMenuTypes.CHANNEL.id">
                        <UpdateDetail v-model="channel" :show-visibility-config="false" />
                    </div>
                    <div v-if="currentTab === WhatsappChannelMenuTypes.VISIBILITY.id">
                        <Visibility v-model="channel" />
                    </div>

                    <div v-if="currentTab === WhatsappChannelMenuTypes.CONTACTS.id">
                        <WhatsappContactList :channel="channel" :channel-id="channel._id" />
                    </div>
                    <div v-if="currentTab === WhatsappChannelMenuTypes.BROADCAST_REQUESTS.id">
                        <BroadcastRequests :channel="channel" :changePage="changePage" />
                    </div>
                    <div v-if="currentTab === WhatsappChannelMenuTypes.CUSTOMER_GROUPS.id">
                        <CustomerGroups :channel="channel" :changePage="changePage" :channel-id="channel._id" />
                    </div>
                    <div v-if="currentTab === WhatsappChannelMenuTypes.WALLET.id" style="padding: 10px">
                        <Wallet />
                    </div>
                </div>
            </div>
        </div>
        <a-modal
            v-model="deleteModal"
            icon="exclamation-circle"
            :title="this.$t('whatsappChannel.whatsappChannel')"
            @cancel="deleteModal = false"
        >
            <p>{{ $t("whatsappChannel.deleteWhatsappChannelDescription") }}</p>
            <template #footer>
                <a-button key="back" @click="deleteModal = false">
                    {{ $t("chatbotv2.dismiss") }}
                </a-button>
                <a-button key="submit" type="danger" @click="deleteWhatsappChannel">
                    {{ $t("chatbotv2.delete") }}
                </a-button>
            </template>
        </a-modal>

        <WhatsappStartChat
            v-if="channel"
            :visibleStartChat="visible"
            :show-alert-message="showAlertMessage"
            :channel-id="channel._id"
            :channel="channel"
            @modal-closed="visible = false"
        />
    </div>
</template>
<script>
import Vue from "vue";
import Numbers from "../WhatsappBusiness/detail/Numbers.vue";
import ChatInitiatorTemplate from "../WhatsappBusiness/detail/ChatInitiatorTemplate.vue";
import ChannelMenu from "./ChannelMenu.vue";
import IconButton from "../Settings/components/IconButton.vue";

import WhatsappContactList from "../WhatsappItem/WhatsappContactList.vue";
import WhatsappIcon from "../Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import Visibility from "../WhatsappBusiness/detail/Visibility.vue";
import WhatsappV2ChannelMenuTypes from "./WhatsappV2ChannelMenuTypes";
import { mapActions, mapGetters, mapState } from "vuex";
import SYSTEM_PUBSUB from "../../../utils/systemPubSub";
import { sendSocketMessage, socketMessageStream } from "../../../utils/socketStream";
import { filter, first, timeout } from "rxjs/operators";
import VueCountryCode from "vue-country-code";
import log2 from "../../../utils/log2";
import UpdateDetail from "./UpdateDetail.vue";
import WhatsappWizard from "./update/WhatsappWizard.vue";
import ContactListV2 from "../WhatsappV1/ContactListV2.vue";
import BroadcastRequests from "../WhatsappBusiness/detail/broadcast/BroadcastRequests.vue";
import CustomerGroups from "../WhatsappBusiness/detail/broadcast/CustomerGroups.vue";
import Wallet from "../Settings/pages/Wallet.vue";
import WhatsappStartChat from "../WhatsappItem/WhatsappStartChat.vue";

const log = log2("W2ChannelDetail.vue");
export default Vue.extend({
    name: "W2ChannelDetail",
    components: {
        CustomerGroups,
        BroadcastRequests,
        WhatsappWizard,
        UpdateDetail,
        VueCountryCode,
        Numbers,
        ChatInitiatorTemplate,
        Visibility,
        ChannelMenu,
        IconButton,
        WhatsappIcon,
        ContactListV2,
        WhatsappContactList,
        Wallet,
        WhatsappStartChat,
    },
    data() {
        const path = (_.last(this.$route.path.split("/")) || "detail").toLowerCase().trim();
        const selected = Object.values(WhatsappV2ChannelMenuTypes).find((x) => x.path === path);
        return {
            currentTab: selected ? selected.id : "detail",
            loading: false,
            selectedChannelId: this.$route.params.id,
            deleteModal: false,
            channel: null,
            WhatsappChannelMenuTypes: WhatsappV2ChannelMenuTypes,
            visible: this.$route.query.action == "start-chat",
            confirmLoading: false,
            whatsappNumber: "",
            showAlertMessage: false,
            dialCode: "+90",
            restartEnabled: true,
        };
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
            userLastCountry: (state) => _.get(state.auth.user, "lastGeoLocation.country"),
            channels: (state) => state.channel.channels.filter((x) => x.type === "whatsapp-v2"),
            siteId: (state) => _.get(state.site.site, "_id"),
            user: (state) => state.auth.user,
            socketConnected: (state) => state.socketStatus.socket_connected,
            site: (state) => state.site.site,
        }),
        ...mapGetters({
            myActiveConversations: "chat/getMyActiveConversations",
        }),
    },
    methods: {
        ...mapActions({
            createChannel: "channel/createChannel",
            listChannels: "channel/listChannels",
            deleteChannel: "channel/deleteChannel",
            updateChannel: "channel/updateChannel",
        }),
        changePage(page) {
            this.currentTab = page;
        },
        toggleChatbot() {
            if (this.showStories) {
                this.form.chatbotStory = null;
            } else {
                if (this.stories[0]) {
                    this.form.chatbotStory = this.stories[0]._id;
                }
            }
            this.showStories = !this.showStories;
        },
        restartChannel() {
            this.$dialog
                .confirm(this.$t("whatsappChannel.wantRestartChannel"), {
                    okText: this.$t("chatbotv2.yes"),
                    cancelText: this.$t("chatbotv2.no"),
                })
                .then(() => {
                    this.restartEnabled = false;
                    sendSocketMessage("whatsapp restart-channel-bot", {
                        channelId: this.channel._id,
                        siteId: this.siteId,
                    });
                    setTimeout(() => {
                        this.restartEnabled = true;
                    }, 5000);
                });
        },
        refreshhannel() {
            this.$dialog
                .confirm(`Are you sure you want to refresh the channel?`, {
                    okText: this.$t("chatbotv2.yes"),
                    cancelText: this.$t("chatbotv2.no"),
                })
                .then(() => {
                    sendSocketMessage("whatsapp v2-refresh-bot", {
                        channelId: this.channel._id,
                        siteId: this.siteId,
                    });
                    this.$message.success("Channel is refreshing");
                });
        },
        deleteWhatsappChannel() {
            const channel = this.channel;
            this.deleteChannel(channel._id).then(() => {
                this.$router.push("/integrations/whatsapp-v2");
            });
        },
        handleSave() {
            const isValid = true;
            if (isValid) {
                const payload = this.channel;
                this.loading = true;
                this.updateChannel(payload)
                    .then(() => {
                        this.listChannels();
                        this.$message.success("Channel updated successfully");
                        this.$emit("ok");
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message.error("Failed to update channel");
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        handleCancel() {
            this.visible = false;
            this.confirmLoading = false;
            this.whatsappNumber = "";
            this.showAlertMessage = false;
        },
        onSelect(value) {
            log("onSelect", value);
            this.dialCode = value.dialCode;
        },
        startChat(whatsappNumber) {
            if (!whatsappNumber.endsWith("@c.us")) {
                whatsappNumber = whatsappNumber + "@c.us";
            }
            log("startChat", { whatsappNumber });
            whatsappNumber = this.dialCode + whatsappNumber;
            const maybeJoinedChat = this.myActiveConversations.find((x) => x.whatsappNumber === whatsappNumber);

            if (!!maybeJoinedChat) {
                SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.OPEN_CHAT, {
                    conversationId: maybeJoinedChat._id,
                });
            } else {
                const hide = this.$message.loading(this.$t("wp.chatStartingWait"), 0);

                socketMessageStream
                    .pipe(
                        filter((x) => x.cmd === "join_chat_immediately"),
                        timeout(5000),
                        first()
                    )
                    .toPromise()
                    .then((x) => {
                        this.$message.success(this.$t("wp.chatStarted"));
                        this.visible = false;
                        this.whatsappNumber = "";
                    })
                    .catch((err) => {
                        this.$message.error(this.$t("wp.chatNotStarted"));
                        this.visible = false;
                    })
                    .finally(() => {
                        hide();
                    });

                sendSocketMessage("user start-chat", {
                    siteId: this.site._id,
                    userId: this.user._id,
                    whatsappNumber,
                    channelId: this.channel._id,
                    channelType: "whatsapp-v2",
                });
            }
        },
    },
    mounted() {
        this.listChannels().then((channels) => {
            this.channel = channels.find((x) => x._id === this.selectedChannelId);
            this.originalChannel = _.cloneDeep(this.channel);
        });
    },
    watch: {
        channel: {
            handler: function (val) {
                if (val) {
                    const isChanged = !_.isEqual(val, this.originalChannel);
                    if (isChanged) {
                        log("channel changed=>", val);
                        this.handleSave();
                    }
                }
            },
            deep: true,
        },
        currentTab(value) {
            const selected = Object.values(WhatsappV2ChannelMenuTypes).find((x) => x.id === value);
            if (selected) {
                this.$router.push(`/integrations/whatsapp-v2/${this.channel._id}/detail/${selected.path}`);
            }
        },
    },
});
</script>

<style scoped lang="scss">
#whatsapp-channel-detail {
    display: flex;
    flex-direction: column;
    background: var(--color-bg-default);
    position: relative;
    width: 100%;
    height: 100%;

    .wrapper {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;

        .toolbar {
            padding: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 50px;
            border: 1px solid var(--color-border-default);

            .left {
                display: flex;
                align-items: center;
                gap: 5px;

                .name {
                    font-size: 18px;
                    font-weight: 700;
                }

                .icon-container {
                    width: 30px;
                    height: 30px;
                    display: flex;
                    margin: 0 auto;
                    align-items: center;
                    justify-content: center;
                    border-radius: 6px;
                    overflow: hidden;
                    position: relative;
                    background: #58ca64;
                    padding: 10px;
                }
            }

            .right {
                display: flex;
                justify-content: flex-end;
                gap: 5px;
            }
        }

        .channel-content {
            display: flex;
            height: 100%;

            .left {
                width: 275px;
                height: 100%;

                .channel-menu {
                    width: 100%;
                }
            }

            .page-content {
                width: calc(100% - 275px);
                height: 100%;
            }
        }
    }
}
</style>
